import { render } from "./IconEditButton.vue?vue&type=template&id=2f45bff6"
import script from "./IconEditButton.vue?vue&type=script&lang=js"
export * from "./IconEditButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__